module.exports = __webpack_public_path__ + "static/media/Nonlinear_Demo.a4263433.jpg";